import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import CommonSelectorModal from "../../form/CommonSelectorModal";
import { useSearchCollectorQuery } from "../../../../features/data/collector/collector";
import { DataTableColumn } from "../DataTableTypes";
import { FaMagnifyingGlass } from "react-icons/fa6";

const CollectorSearchInputWrapper = ({ value = '', onChange, accessor, onCollectorSelect }: any) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState<any>({});
    const [displayValue, setDisplayValue] = useState('');

    useEffect(() => {
        setDisplayValue(value || '');
    }, [value]);

    const handleSelect = () => {

        if (!selectedRow?.name) return;
        // Send filter value and display value to parent
        onChange({
            target: {
                name: accessor,
                value: accessor === "collectorName" ? selectedRow?.name : selectedRow?.id,
            },
        });

        onChange({
            target: {
                name: accessor + "ShowValue",
                value: accessor === "collectorName" ? selectedRow?.name : selectedRow?.id,
            },
        });

        setDisplayValue(selectedRow.name);

        if (onCollectorSelect) {
            onCollectorSelect(selectedRow);
        }

        setShowModal(false);
    };

    const columns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "name",
            filterOptions: [{
                filterModalOption: {
                    filterModalPlaceHolder: "Enter Name...",
                    filterModalKey: "name",
                    filterModalIcon: <FaMagnifyingGlass size={14} />
                },
                overrideFilterLabel: " ",
                overrideFilterAccessor: "name"
            }],
        },
    ];

    return (
        <>
            <div
                className="relative w-full"
                onClick={() => setShowModal(true)}
            >
                <input
                    type="text"
                    name={accessor + "ShowValue"}
                    value={displayValue}
                    readOnly
                    placeholder="Select Collector"
                    className="border border-surface-5 p-2 placeholder:text-text-3 rounded-md text-text-7 w-full bg-text-1 cursor-pointer"
                />
                {displayValue ? (
                    <span
                        className="absolute bottom-2 right-2 cursor-pointer text-gray-500 text-xl"
                        onClick={(e) => {
                            e.stopPropagation(); // prevent modal from opening
                            setDisplayValue('');
                            onChange({ target: { name: accessor, value: '' } });
                            onChange({ target: { name: accessor + "ShowValue", value: '' } });
                            if (onCollectorSelect) {
                                onCollectorSelect(null);
                            }
                            if (onCollectorSelect) {
                                onCollectorSelect(null);
                            }
                        }}
                    >
                        &times;
                    </span>
                ) : (
                    <FaSearch
                        className="absolute top-2.5 right-2 cursor-pointer text-gray-500"
                    />
                )}
            </div>

            {showModal && (
                <CommonSelectorModal
                    title="Select Collector"
                    columns={columns}
                    data={useSearchCollectorQuery}
                    show={showModal}
                    onSubmit={handleSelect}
                    customerFilter={{
                        sort: "name",
                        sortOrder: "ASCENDING"
                    }}
                    
                    setShow={setShowModal}
                    setSelectedRow={setSelectedRow}
                />
            )}
        </>
    );
};

export default CollectorSearchInputWrapper;
